export default __webpack_public_path__ + "images/plumber.2b8337b999c95e566aa3cbd92e672e7b.svg";